<template>
    <div>
        <div class="toolbar">
            <SearchForm @change="fetchData" ref="search" style="display:inline-block;margin-right:15px;"></SearchForm>
        </div>
        <el-table ref="multipleTable" :data="tableData" border style="width: 100%" @sort-change="handleSort">
            <el-table-column prop="id" label="编号" sortable="custom" width="100"></el-table-column>
            <el-table-column prop="level" label="等级" sortable="custom" width="100"></el-table-column>
            <el-table-column prop="lesson.num" label="课程" width="100"></el-table-column>
            <el-table-column prop="text" label="语言点"></el-table-column>
            <el-table-column prop="pinyin" label="拼音"></el-table-column>
            <el-table-column prop="type.name" label="分类"></el-table-column>
            <el-table-column prop="showType.name" label="展示分类"></el-table-column>
            <el-table-column prop="memo" label="内部备注"></el-table-column>
            <el-table-column fixed="right" label="操作" width="60">
                <template slot-scope="scope">
                    <el-button @click="data=scope.row" type="text" size="small">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="total>pageSize">
        </el-pagination>
    </div>
</template>
<script>
import table from './../mixins/table.js'
import SearchForm from './../SearchForm'

export default {
    name: 'GrammarSearch',
    data() {
        return {
            fetchUrl: 'grammar_list',
            data: null,
        }
    },
    props: {
        value: Object,
    },
    mixins: [table],
    components: { SearchForm },
    watch: {
        search() {
            this.fetchData()
        },
        searchType() {
            this.fetchData()
        },
        data(newVal, oldVal) {
            var data = { grammar: this.data }
            this.$emit('input', data)
            this.$emit('closeSearchBox')
        },
    },
    methods: {
        handleFetchConfig(config) {
            if (this.$refs.search) {
                Object.assign(config.params, {
                    "filter[status]": null,
                    "filter[and][0][status]": 1,
                    "filter[and][0][level]": this.$refs.search.level || null,
                    "filter[and][0][num]": this.$refs.search.num || null,
                    "filter[and][1][or][0][text][like]": this.$refs.search.search || null,
                    "filter[and][1][or][1][pinyin][like]": this.$refs.search.search || null,
                    "filter[and][1][or][2][explain][like]": this.$refs.search.search || null,
                    "filter[and][1][or][3][memo][like]": this.$refs.search.search || null
                })
            }
        },
    }
}
</script>